var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 40,
      stroke: "rgb(0, 255, 0)"
    },
    x1: 90.001,
    y1: 24.28,
    x2: 359.559,
    y2: 235.209
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeMiterlimit: 40,
      strokeLinecap: "round",
      strokeWidth: 40,
      stroke: "rgb(0, 255, 0)"
    },
    x1: 227.867,
    y1: 178.5,
    x2: 227.867,
    y2: 408.92
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 0)"
    },
    cx: 228.456,
    cy: 132.966,
    r: 47.966
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 0)"
    },
    cx: 395.183,
    cy: 264.913,
    r: 47.966
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 0)"
    },
    cx: 226.867,
    cy: 450.966,
    r: 47.966
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitLogo);
export default __webpack_public_path__ + "static/media/gitLogo.7bed215af239ddbe8eeee0b23aa30cb0.svg";
export { ForwardRef as ReactComponent };